import { NameDto } from '../../Common/Types'
import { CurrencyType } from '../../Wallet/Types/Wallet'

export interface AccountGroupDto {
  id: string
  name: string
  tradingAccountType: NameDto
  platformType: NameDto
  accountGroupType: NameDto
  bookType: NameDto | null
  classificationType: NameDto
  tickmillCompany: NameDto
  currency: NameDto<string | CurrencyType>
  country: NameDto<string> | null
  externalId: string
  isEnabled: boolean
  isSwapFree: boolean
  isStocks: boolean
  isFutures: boolean
  isPerpetuals: boolean
  canBeDirectAssigned: boolean
  canBeIBAssigned: boolean
  canBeAttached: boolean
  servers: { id: string; name: string }[]
  restrictions: NameDto[] | null
  selected: boolean
}

export enum AccountGroupKey {
  ID = 'id',
  NAME = 'name',
  TRADING_ACCOUNT_TYPE = 'tradingAccountType.name',
  PLATFORM_TYPE = 'platformType.name',
  ACCOUNT_GROUP_TYPE = 'accountGroupType.name',
  BOOK_TYPE = 'bookType.name',
  CLASSIFICATION_TYPE = 'classificationType.name',
  TICKMILL_COMPANY = 'tickmillCompany.name',
  CURRENCY = 'currency.id',
  COUNTRY = 'country.name',
  EXTERNAL_ID = 'externalId',
  IS_ENABLED = 'isEnabled',
  IS_SWAP_FREE = 'isSwapFree',
  CAN_BE_DIRECT_ASSIGNED = 'canBeDirectAssigned',
  CAN_BE_IB_ASSIGNED = 'canBeIBAssigned',
  CAN_BE_ATTACHED = 'canBeAttached',
  SERVERS = 'servers',
}

export interface AccountGroupBasicDto {
  id: string
  name: string
  bookType: NameDto | null
  currency: {
    id: CurrencyType | string
    name: string
  }
}

export enum AccountGroupFilterKey {
  NAME = 'Name',
  TRADING_ACCOUNT_TYPE = 'AccountType',
  ACCOUNT_GROUP_TYPE = 'AccountGroupType',
  BOOK_TYPE = 'Book',
  CLASSIFICATION_TYPE = 'ClassificationTypeId',
  CURRENCY = 'Currency',
  COUNTRY = 'Country',
  IS_ENABLED = 'IsEnabled',
  IS_SWAP_FREE = 'IsSwapFree',
  SERVERS = 'Server',
  TICKMILL_COMPANY = 'TickmillCompanyId',
  PLATFORM = 'Platform',
}
